import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { PageTitle } from '@tiendanube/components';
import useTopBar from 'App/components/Topbar/useTopBar';

import './Title.scss';

export interface TitleProps {
  text: string | 'skeleton';
}

const THRESHOLD_LIMIT = 32;

function Title({ text }: TitleProps): JSX.Element {
  const { isShowTopbar } = useTopBar();
  const [isInsideAsideModal, setIsInsideAsideModal] = useState(true);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const refTitle = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const backNavigation = document.querySelector('#back-navigation-topbar');
    const backNavigationLeft = (
      backNavigation as HTMLElement
    )?.getBoundingClientRect().left;
    const titleLeft = (refTitle.current as HTMLElement)?.getBoundingClientRect()
      .left;
    setIsIntersecting(
      Math.abs(backNavigationLeft - titleLeft) < THRESHOLD_LIMIT,
    );
    if (!refTitle.current?.closest('.modal-aside-content__container')) {
      setIsInsideAsideModal(false);
    }
  });

  return text === 'skeleton' ? (
    <PageTitle.Skeleton />
  ) : (
    <div
      ref={refTitle}
      className={classNames({
        'stratus--fixed--page-title-intersecting':
          isIntersecting && !isInsideAsideModal && !isShowTopbar,
        'stratus--fixed--page-title-not-intersecting':
          !isIntersecting && !isInsideAsideModal && !isShowTopbar,
      })}
    >
      <PageTitle title={text} />
    </div>
  );
}

export default Title;
